import { Badge, formatDate, Image } from "@";

// Columns configuration for classifications table
export const classificationsColumns = [
  {
    name: "",
    grow: 0,
    cell: ({ imageFullUrl }) => <Image size={64} src={imageFullUrl} />,
  },
  {
    name: "الاسم",
    selector: ({ name }) => name,
    grow: 2,
  },
  {
    name: "عرض في",
    grow: 2,
    cell: ({ showOnHomePage, showOnFastDonation }) => (
      <div className="flex flex-col justify-start gap-1 md:flex-row md:items-center md:justify-center md:gap-3">
        {showOnHomePage && <Badge title="الصفحة الرئيسية" color="default" />}
        {showOnFastDonation && <Badge title="التبرع السريع" color="default" />}
      </div>
    ),
  },
  {
    name: "الحالة ",
    cell: ({ isActive }) => (
      <Badge
        title={isActive ? "مفعل" : "غير مفعل"}
        color={isActive ? "green" : "red"}
      />
    ),
  },
];

// Columns configuration for licenses table
export const licensesColumns = [
  {
    name: "",
    grow: 0,
    cell: ({ licence }) => <Image size={64} src={licence} />,
  },
  {
    name: "الاسم",
    grow: 2,
    cell: ({ title, isDefault }) => (
      <span className="flex items-center gap-2">
        {title}
        {isDefault && <Badge title="الترخيص الافتراضي" color="green" />}
      </span>
    ),
  },
  {
    name: "الجهة المصدرة",
    selector: ({ issuer }) => issuer,
    grow: 2,
  },
  {
    name: "تاريخ الانتهاء",
    selector: ({ issueDate }) => formatDate(issueDate),
  },
];
